export const getEmojiNumber = (emojiNumber: number): string => {
  switch(emojiNumber){
    case 1: return '1️⃣'; 
    case 2: return '2️⃣';
    case 3: return '3️⃣';
    case 4: return '4️⃣';
    case 5: return '5️⃣'; 
    case 6: return '6️⃣';
    case 7: return '7️⃣'; 
    case 8: return '8️⃣';
    case 9: return '9️⃣';
    case 10: return '🔟';
    default: return '';
  }
}

const getFirstNumber = (value: string): number | null => {
  const match = value.match(/-?\d+(?:[.,]\d+)?/);
  if (match == null) {
    return null;
  }

  const parsedNumber = Number(match[0].replace(',', '.'));
  return Number.isNaN(parsedNumber) ? null : parsedNumber;
};

export const sortNumerically = (values: string[]): string[] => {
  return [...values].sort((firstValue, secondValue) => {
    const firstNumber = getFirstNumber(firstValue);
    const secondNumber = getFirstNumber(secondValue);

    if (firstNumber != null && secondNumber != null && firstNumber !== secondNumber) {
      return firstNumber - secondNumber;
    }
    if (firstNumber != null && secondNumber == null) {
      return -1;
    }
    if (firstNumber == null && secondNumber != null) {
      return 1;
    }

    return firstValue.localeCompare(secondValue, undefined, { numeric: true });
  });
};
